import { CustomerCarbonCropList } from "portal/components/carbonCrop/CustomerCarbonCropList";
import { CustomerScopeSelector } from "portal/components/customers/CustomerScopeSelector";
import { Header } from "portal/components/header/Header";
import { Page } from "portal/components/Page";
import {
  useCanUpdateCarbonCropsPage,
  withCarbonCropsPageReadAccess,
} from "portal/views/carbonCrops/permissions";
import { useCustomerScopeFilter } from "portal/components/customers/useCustomerScopeFilter";
import { useTranslation } from "react-i18next";
import React, { FC } from "react";

const _CarbonCropList: FC = () => {
  const { t } = useTranslation();
  const canUpdate = useCanUpdateCarbonCropsPage();
  const { customerUuid } = useCustomerScopeFilter();

  return (
    <>
      <Header title={t("views.carbonCrops.title")}>
        <CustomerScopeSelector />
      </Header>
      <Page>
        {customerUuid && (
          <CustomerCarbonCropList
            customerUuid={customerUuid}
            canUpdate={canUpdate}
          />
        )}
      </Page>
    </>
  );
};

export const CarbonCropList = withCarbonCropsPageReadAccess(_CarbonCropList);
